import {BannerComponent} from "../../../../../components/banner/banner.component";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {BannerConfig} from "../../arenas/arena-base.model";

export class PromotionalBannerModel {
    constructor(private readonly services: IServiceFactoryExtended,
        public readonly arenaName: string,
        private readonly _bannerConfig: BannerConfig | null) {

    }
    private _getBannerMinHeightInPixels(listPosition: number, numberOfListsInCurrentArena: number, bannerConfig: BannerConfig | null) {
        if (!bannerConfig) {
            return 0;
        }

        const shouldRenderBanner = listPosition === bannerConfig.position
            || (numberOfListsInCurrentArena < bannerConfig.position && listPosition === numberOfListsInCurrentArena);
        if (!shouldRenderBanner) {
            return 0;
        }

        if (this.services.mediaQuery.sAndBelow) {
            return 142;
        }

        return 223;
    }

    render(listPosition: number, numberOfListsInCurrentArena: number): React.ReactElement {
        const bannerMinHeight = this._getBannerMinHeightInPixels(listPosition, numberOfListsInCurrentArena, this._bannerConfig);
        if (bannerMinHeight === 0) {
            return null;
        }

        return (
            <BannerComponent
                key={`${this.arenaName}_ARENA_PROMOTIONAL_BANNER_${listPosition}`}
                showPlaceholder={false}
                templateID={this._bannerConfig.templateID}
                componentID={this._bannerConfig.componentID}
                fallbackComponent={this._bannerConfig.fallbackComponent}
                minHeight={bannerMinHeight + 'px'}
                bannerAdminPlaceholderId={this._bannerConfig.bannerAdminPlaceholderId}
            />
        );
    }
}